import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import type { OriginalsConfig, PlayEnvelope } from '../types.js';
import type { ScenePhase, SceneComponent, SceneSelection } from '../scenes/types.js';
import { WinCelebration } from '../effects/WinCelebration.js';

interface Props {
  Scene: SceneComponent;
  config: OriginalsConfig;
  envelope: PlayEnvelope | null;
  phase: ScenePhase;
  turbo: boolean;
  onRevealComplete: () => void;
  celebration: { payout: string; multiplier: string; big: boolean } | null;
  selection?: SceneSelection;
  /** DOM selection overlay rendered above the scene (dice board / keno grid). */
  overlay?: ReactNode;
}

// The play area inside the unified game card. No own border/rounded or fill — the
// parent card frames it and the game's themed stage column paints behind it.
export const GameStage = forwardRef<HTMLDivElement, Props>(function GameStage(props, ref) {
  const { Scene } = props;
  return (
    <div ref={ref} className="relative w-full overflow-hidden">
      <Scene
        config={props.config}
        envelope={props.envelope}
        phase={props.phase}
        turbo={props.turbo}
        onRevealComplete={props.onRevealComplete}
        selection={props.selection}
      />
      {props.overlay}
      <WinCelebration
        show={props.phase === 'revealed' && props.celebration != null}
        amountMinor={props.celebration?.payout ?? '0'}
        multiplier={props.celebration?.multiplier ?? '0'}
        big={props.celebration?.big ?? false}
        // cards/dice: the result IS the centre of the stage (card faces, dice +
        // sum readout) — a centred banner would cover it, so drop to the bottom band
        align={props.config.gameType === 'cards' || props.config.gameType === 'dice' ? 'bottom' : 'center'}
      />
    </div>
  );
});
